import React from "react";
import { inject, observer } from "mobx-react";
import ToolbarMenu from "@components/Toolbar/toolbarmenu";
import TopBar from "@components/Navigation/topbar-site";
import ReactResizeDetector from 'react-resize-detector';
import Footer from "@templates/footer"
import classnames from "classnames";

import MarketSelectorPanel from '@components/Navigation/market-selector-panel';
import TickerBar from "@components/Navigation/tickerbar";
import DocTypeTicker from "@components/IComDocType/DocTypes/DocTypeTicker";
import ScrollToTop from "react-scroll-to-top";

@inject("store")
@observer
export default class Master extends React.Component {
    //targetElement = null;
    constructor(props) {
        super(props);

        // Server?
        const serverRender = typeof window === 'undefined';

        this.onOuterElementClick = this.onOuterElementClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.ref = React.createRef();
        this.elementRef = React.createRef();
        this.scollToTop = this.scrollToTop.bind(this);
        this.state = { touchLock: !serverRender ? window.innerWidth <= 768 : true }
    }



    scrollToTop(reason) {
        const serverRender = typeof window === 'undefined';
        if (serverRender) return;

        var navigation = this.props.store.navigation;
        var lastAction = navigation.mainRouter.action;
        
        if(lastAction !== "POP") {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }

    onOuterElementClick(e) {
        //console.debug("onOuterElement", e);
        //this.props.store.navigation.closeToolbar();
    }
    
    onResize(w, h) {
        
        if (w < 769 && !this.state.touchLock) {
            this.setState({ touchLock: true });
            console.debug("setTouchLock true")
        }
        else if (w > 768 && this.state.touchLock) {
            this.setState({ touchLock: false });
            console.debug("setTouchLock false")
        }
    }


    componentDidMount() {

        if (this.props.headerCallback) {
            // avoid re-render header when switching template
            this.props.headerCallback(this.renderHeader());
        }

        const serverRender = typeof window === 'undefined';
        if (serverRender) return;
        this.previousUrl = this.props.store.navigation.pageContent.Url;
        this.previousFacets = this.props.store.navigation.getSearchFromFacets();
        this.scrollToTop("didMount");
    }

    componentDidUpdate(prevProps, prevState) {
        
        if (this.props.store.navigation.pageContent && this.props.store.navigation.pageContent.Url !== this.previousUrl) {
            this.scrollToTop("didUpdate - url changed");
            this.previousUrl = this.props.store.navigation.pageContent.Url;
        }
        else if(this.props.store.navigation.getSearchFromFacets() !== this.previousFacets) {
            this.scrollToTop("didUpdate - facets changed");
            this.previousFacets = this.props.store.navigation.getSearchFromFacets();
        }
        
    }

    componentWillUnmount() {
        //clearAllBodyScrollLocks();
    }


    renderHeader() {
        return (<Header
            key={"header"}
            ref={this.ref}
        >

                    <TickerBar/>                    
                    <TopBar />
                    <MarketSelectorPanel navigation={this.props.store.navigation} />
                    <ul
                        className="header-navigation">

                        <li
                            className="toolbar-area">
                            <ToolbarMenu />
                        </li>
                    </ul>
            {/*    </React.Fragment>*/}
            {/*</IcomRouter>*/}
            
        
        </Header>);
    }


    renderCountdown() {
        const navigation = this.props.store.navigation;
        if (!navigation) return null;
        const countdownData = navigation.countdownContent;
        if (!countdownData) return null;
        const counters = countdownData.Counters;
        if (!counters) return null;
        return counters.map((c, index) =>
            <DocTypeTicker
            key={"ticker_" + index}    
                model={{
                
                fg: c.Fg,
                bg: c.Bg,
                deadline: c.Deadline,
                text: c.Html
            }}/>);
    }

    render() {
        const navigation = this.props.store.navigation;

        const serverRender = typeof window === 'undefined';

        // if (!serverRender) {
        //     document.title = navigation.pageContent.Title;
        // }
        
        const darkMode = navigation.pageContent.Properties.darkMode || false;
        const fullWidth = navigation.pageContent.Properties.fullWidth || false;

        const pageContentClasses = [
            "page-content",
            this.props.store.navigation.TemplateAlias,
            darkMode ? "dark" : "",
            fullWidth ? "fullwidth" : ""
        ];

        // Handle serverLocation or client location
        return [
                this.renderHeader(),
                <div key={"page-content"} 
                     className={pageContentClasses.join(" ")}
                     onClick={(e) => this.props.store.navigation.aHrefNavigation(e)}
                >
                    {this.renderCountdown()}
                    {this.props.children}
                    <ReactResizeDetector handleWidth onResize={this.onResize} />
                </div>,
                <Footer key={'footer'} />,
                <ScrollToTop
                    key={"scrollToTop"}
                    style={{backgroundColor:"transparent", boxShadow:"none", padding:0, zIndex:10}}
                    
                    smooth component={<svg width="32" height="32" viewBox="0 0 100 100">
                    <circle fill="white" cx="50" cy="50" r="40"></circle>
                    <path fill="black" d="m50 0c-13.262 0-25.98 5.2695-35.355 14.645s-14.645 22.094-14.645 35.355 5.2695 25.98 14.645 35.355 22.094 14.645 35.355 14.645 25.98-5.2695 35.355-14.645 14.645-22.094 14.645-35.355-5.2695-25.98-14.645-35.355-22.094-14.645-35.355-14.645zm20.832 62.5-20.832-22.457-20.625 22.457c-1.207 0.74219-2.7656 0.57812-3.7891-0.39844-1.0273-0.98047-1.2695-2.5273-0.58594-3.7695l22.918-25c0.60156-0.61328 1.4297-0.96094 2.2891-0.96094 0.86328 0 1.6914 0.34766 2.293 0.96094l22.918 25c0.88672 1.2891 0.6875 3.0352-0.47266 4.0898-1.1562 1.0508-2.9141 1.0859-4.1133 1z"></path>
                </svg>}/>

        ];
    }
}




@inject("store")
@observer
class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            prevScrollpos: 0,
            visible: true,
            noAnimation: false,
        };
    }

    handleScroll = () => {

        return;
        const serverRender = typeof window === 'undefined';
        const navigation = this.props.store.navigation;

        if (serverRender || navigation.navigationVisible) return;

        const { prevScrollpos } = this.state;

        const currentScrollPos = window.pageYOffset;
        const visible = currentScrollPos < 170 || (prevScrollpos - 25) > currentScrollPos;
        const noAnimation = currentScrollPos < 170;
        if (prevScrollpos < currentScrollPos || visible) {

            this.setState({
                prevScrollpos: currentScrollPos,
                visible,
                noAnimation
            });
        }
    };


    componentDidMount() {
        const serverRender = typeof window === 'undefined';
        if (serverRender) return;
        this.setState({ prevScrollpos: window.pageYOffset });
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        const serverRender = typeof window === 'undefined';
        if (serverRender) return;

        window.removeEventListener("scroll", this.handleScroll);
    }

    render() {
        
        return (
            <header className={classnames("navbar navbar-sticky", {
                "navbar--hidden": !this.state.visible,
                "navbar--no-animation": this.state.noAnimation
            })}>
                {this.props.children}
            </header>
        );


    }
}

